// @flow

import { createContext } from 'react';
import { type FormStatusContextType } from './types';

export const FormStatusContext = createContext<?FormStatusContextType>(null);
